import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import ContactHeroSection from './components/ContactHeroSection';
import ContactFormSection from './components/ContactFormSection';
import OfficeLocationsSection from './components/OfficeLocationsSection';

const ContactPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleContactFormFocus = () => {
    const formSection = document.getElementById('contact-form');
    if (formSection) {
      const headerHeight = 80;
      const targetPosition = formSection.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <ContactHeroSection onContactFormFocus={handleContactFormFocus} />
        <ContactFormSection />
        <OfficeLocationsSection />
      </main>

      {/* Footer */}
      <footer className="bg-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-10 h-10 bg-white rounded-lg">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 21L12 2L21 21H3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="var(--color-primary)"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold">AlumERP</h3>
                  <p className="text-sm opacity-80">
                    {currentLanguage === 'en' ? 'Aluminum Extrusion ERP' : 'एल्यूमीनियम एक्सट्रूज़न ERP'}
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-80 leading-relaxed mb-6">
                {currentLanguage === 'en' ?'Ready to transform your aluminum extrusion business? Our expert team is here to help you succeed. Contact us today for a personalized consultation.' :'अपने एल्यूमीनियम एक्सट्रूज़न व्यवसाय को बदलने के लिए तैयार हैं? हमारी विशेषज्ञ टीम आपकी सफलता में मदद करने के लिए यहां है। व्यक्तिगत परामर्श के लिए आज ही हमसे संपर्क करें।'}
              </p>
              <div className="flex space-x-4">
                <div className="text-center">
                  <div className="text-2xl font-bold">2h</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Response Time' : 'प्रतिक्रिया समय'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">1000+</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Consultations' : 'परामर्श'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">98%</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Satisfaction' : 'संतुष्टि'}
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Methods */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Contact Methods' : 'संपर्क विधियां'}
              </h4>
              <ul className="space-y-2 text-sm opacity-80">
                <li><a href="tel:+919876543210" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Phone Call' : 'फोन कॉल'}
                </a></li>
                <li><a href="mailto:contact@alumerp.com" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Email' : 'ईमेल'}
                </a></li>
                <li><a href="https://wa.me/919876543210" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'WhatsApp' : 'व्हाट्सऐप'}
                </a></li>
                <li><a href="#contact-form" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Contact Form' : 'संपर्क फॉर्म'}
                </a></li>
              </ul>
            </div>

            {/* Office Hours */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Office Hours' : 'कार्यालय समय'}
              </h4>
              <div className="space-y-2 text-sm opacity-80">
                <p>
                  {currentLanguage === 'en' ? 'Monday - Friday' : 'सोमवार - शुक्रवार'}
                </p>
                <p>9:00 AM - 6:00 PM</p>
                <p>
                  {currentLanguage === 'en' ? 'Emergency Support: 24/7' : 'आपातकालीन सहायता: 24/7'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;